module.exports = __webpack_public_path__ + "static/img/home_service_02.zh.a80cd82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_service_02.zh.png
// module id = LZTO
// module chunks = 34